
import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Message } from 'primeng/message';
import { Router } from '@angular/router';
import { SsoService } from '../../../core/services/sso.service';
import { MfaForm } from '../../../models/form.model';
import { User } from '../../../models/user.model';
import { SessionService } from '../../../core/security/session.service';
import { LoggerService } from '@danangelus/ngx-app-core';

const log = LoggerService.get('EnrollSmsMfaComponent');

@Component({
  selector: 'app-enroll-sms-mfa',
  standalone: true,
  imports: [CommonModule, FormsModule, Message],
  templateUrl: './enroll-sms-mfa.component.html',
  styleUrl: './enroll-sms-mfa.component.sass',
})
export class EnrollSmsMfaComponent implements OnInit {
      private readonly ssoService = inject(SsoService);
      private readonly router = inject(Router);
      private readonly sessionService = inject(SessionService);

      form: MfaForm = { code: '', errors: {} };
      mobileNumber = '';
      showMobileInput = false;
      smsSent = false;
      success = false;
      errorMsg = '';

      async ngOnInit(): Promise<void> {
        await this.checkMobileAndSendSms();
      }

      async checkMobileAndSendSms(): Promise<void> {
        log.info('checkMobileAndSendSms', 'Checking if the User has registered their phone number and sending a code');
        this.errorMsg = '';
        try {
          const result = await this.ssoService.enrollSmsMfa(this.mobileNumber, '');
          if (result === true) {
            this.smsSent = true;
            this.showMobileInput = false;
          } else if (
            result && typeof result === 'object' &&
            'error' in result &&
            typeof result.error === 'string' &&
            result.error.includes('NOT_EXISTS')
          ) {
            this.showMobileInput = true;
            this.smsSent = false;
            this.errorMsg = result.error;
          } else if (result && typeof result === 'object' && 'error' in result) {
            this.errorMsg = result.error || 'Unknown error';
          }
        } catch (e) {
          log.error(`Error when setting up SMS for MFA: ${e}`);
          this.errorMsg = 'Unknown error';
        }
      }

      async submitMobileNumber(): Promise<void> {
        this.errorMsg = '';
        await this.checkMobileAndSendSms();
      }

      async verifySmsCode(): Promise<void> {
        log.info('verifySmsCode', 'Verifying the submitted SMS code');
        this.form.errors.code = '';
        if (!this.form.code || this.form.code.length !== 6) {
          this.invalidCode();
          return;
        }
        try {
          const user = await this.ssoService.checkMfaCode(this.form!.code!, 'sms', true);
          if (user instanceof User && user.verified) {
            this.success = true;
            this.sessionService.userVerified(new User(user));
            await this.router.navigate(['home']);
          } else {
            this.invalidCode();
          }
        } catch {
          this.invalidCode();
        }
      }

      private invalidCode(): void {
        this.form.errors.code = 'INVALID_CODE';
        this.errorMsg = 'Invalid code.';
      }
}
